import { AdvertisingMetric } from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/AdvertisingConstants';
import { BEACON_INDEX_FIELDS } from 'src/utils/entityDefinitions/indexes/beaconIndexDefinitions';
import { isCriteo } from 'src/utils/app';

export const AdClickField = {
  name: AdvertisingMetric.AD_CLICK,
  displayName: 'Ad\nClicks'
};

export const AdSpendField = {
  name: AdvertisingMetric.AD_SPEND,
  displayName: 'Ad\nSpend'
};

export const AdSalesField = {
  name: AdvertisingMetric.AD_SALES,
  displayName: 'Ad\nSales'
};

export const ROASField = {
  name: AdvertisingMetric.ROAS,
  displayName: 'ROAS'
};

export const CPCField = {
  name: AdvertisingMetric.CPC,
  displayName: 'CPC'
};

const ConstantExportFields = [
  BEACON_INDEX_FIELDS.advertising.impressions,
  AdClickField,
  AdSpendField,
  AdSalesField,
  BEACON_INDEX_FIELDS.advertising.unitsSold,
  CPCField,
  ROASField,
  BEACON_INDEX_FIELDS.advertising.costPerAcquisition,
  BEACON_INDEX_FIELDS.advertising.adCostOfSales
];

export const retailerCustomExportFields = {
  amazon: [
    ...ConstantExportFields,
    BEACON_INDEX_FIELDS.advertising.avgIncrementality,
    BEACON_INDEX_FIELDS.advertising.brandTotalClicksIncrementalClicks,
    BEACON_INDEX_FIELDS.advertising.brandTotalClicksIncrementalSales,
    BEACON_INDEX_FIELDS.advertising.brandTotalClicksIncrementalUnitsOrders,
    BEACON_INDEX_FIELDS.advertising.brandTotalClicksIncrementalROAS,
    BEACON_INDEX_FIELDS.advertising.sameSKUSales,
    BEACON_INDEX_FIELDS.advertising.sameSKUConversions
  ],
  walmart: [...ConstantExportFields],
  criteo: [
    ...ConstantExportFields,
    BEACON_INDEX_FIELDS.advertising.sameSKUSales,
    BEACON_INDEX_FIELDS.advertising.sameSKUConversions,
    BEACON_INDEX_FIELDS.advertising.sameCategorySales,
    BEACON_INDEX_FIELDS.advertising.sameCategoryConversions
  ],
  instacart: [...ConstantExportFields]
};

export const getRetailerKey = (retailer: string) => {
  const standardizeRetailer = retailer.toLowerCase();
  const isCriteoRetailer = isCriteo();

  if (isCriteoRetailer) {
    return 'criteo';
  }

  if (standardizeRetailer.includes('amazon')) {
    return 'amazon';
  }
  if (standardizeRetailer.includes('walmart')) {
    return 'walmart';
  }
  if (standardizeRetailer.includes('instacart')) {
    return 'instacart';
  }
  return standardizeRetailer;
};
